<template>
  <div>
    <modal v-if="isModalOpen" @close="closeModal">
      <div slot="header">
        <h1>Service Mode</h1>
      </div>
      <div slot="body">
        <pre>{{ deviceSerial }}</pre>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '../_common/modal.vue';

export default {
  name: 'ServiceMode',
  components: {
    Modal
  },
  data() {
    return {
      deviceSerial: undefined,
      isModalOpen: true
    };
  },
  created() {
    this.setDeviceSerial();
  },
  methods: {
    /**
     * Function to either retrieve device serial via url query parameter,
     * or to use the currently selected device as a fallback.
     */
    setDeviceSerial() {
      if (this.$route.query.hasOwnProperty('serial')) {
        this.deviceSerial = this.$route.query.serial;
      } else if (this.device) {
        this.deviceSerial = this.device.serial;
      } else {
        this.$log.error('ServiceMode::setDeviceSerial() -> no serial was provided');
      }
    },

    closeModal() {
      // if there is a previous route, navigate to it. Otherwise go to home route.
      // We check for > 2 because an empty browser tab/page counts already as one
      // and we want to ensure that closing this modal will not lead to a blank tab/page.
      if (window.history && window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    }
  },
  computed: {
    ...mapGetters(['device'])
  }
};
</script>

<style lang="scss" scoped></style>
